/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import Register from "@/components/pages/Register";
import Login from "@/components/pages/Login";
import Error from "@/components/pages/Error";
import Password from "@/components/pages/NewPassword";
import ForgotPassword from "@/components/pages/ForgotPassword";
import EmailConfirmed from "@/components/pages/EmailConfirmed";
import GenerateToken from "@/components/pages/shs/GenerateToken";
import TokenHistory from "@/components/pages/shs/TokenHistory";
import Wallet from "@/components/pages/shs/Wallet";
import TransactionResponse from "@/components/pages/shs/TransactionResponse";
import ravePay from "@/components/pages/shs/ravepay";
import New from "@/components/pages/devices/New";
import List from "@/components/pages/devices/List";
import Devices from "@/components/pages/devices/Devices";
import DeviceRequest from "@/components/pages/devices/Request";
import ManageRequests from "@/components/pages/devices/ManageRequests";
import deviceRequestStatus from "@/components/pages/devices/deviceRequestStatus";
import View from "@/components/pages/devices/View";
import Kitchen from "@/components/pages/kitchen/index";
import UsersIndex from "@/components/pages/users/index";
import UsersCreate from "@/components/pages/users/new-user";
import BillingCreate from "@/components/pages/users/new-billing";
import BillingUpdate from "@/components/pages/users/BillingUpdate";
import CustomerCreate from "@/components/pages/users/new-customer";
import UsersAllow from "@/components/pages/users/allow";
import EditsAllow from "@/components/pages/users/edit-user";
import ProfileEdit from "@/components/pages/users/edit-profile";
import UserDetails from "@/components/pages/users/details";
import FinishTab from "@/components/pages/kitchen/Onboarding/FinishTab";
import Billing from "@/components/pages/billing/Billing";
import TransactionHistory from "@/components/pages/billing/TransactionHistory";
import OnboardingTracker from "@/components/pages/onboardingTracker/OnboardingTracker";
import AdminBilling from "@/components/pages/adminBilling/AdminBilling";
import LuxOnboarding from "@/components/pages/luxOnboarding/LuxOnboarding";
import LuxDeviceUpdate from "@/components/pages/luxOnboarding/LuxDeviceUpdate";
import ListLuxUsers from "@/components/pages/luxOnboarding/ListLuxUsers";
import AdminTransactionHistory from "@/components/pages/adminBilling/AdminTransactionHistory";

import Dashboard from "@/components/pages/dashboard/index";
import Inventory from "@/components/pages/inventory/index";
import PackagesMgmt from "@/components/pages/inventory/packages";
import Components from "@/components/pages/inventory/components";
import Roles from "@/components/pages/roles/index";
import ReportConfig from "@/components/pages/report/config";
import Alarm from "@/components/pages/alarm/alarmConfig";
import Enquiries from "@/components/pages/enquiries/index";
import viewEnquiries from "@/components/pages/enquiries/view";
import addInstallation from "@/components/pages/instalation/addInstalation";
import listInstallation from "@/components/pages/instalation/instalationList";
import instalationSchedule from "@/components/pages/instalation/instalationSchedule";
import ongoingInstallation from "@/components/pages/instalation/ongoingInstalation";
import inventoryRequest from "@/components/pages/instalation/inventoryRequest";
import installationCommission from "@/components/pages/instalation/installationCommission";
import devicePerformance from "@/components/pages/performance/details";
import devicePerformanceV2 from "@/components/pages/performance/detailsV2";
import geoDistribution from "@/components/pages/performance/geoDistro";
import PerformanceV2 from "@/components/pages/performance/index3.vue";
import rightBar from "@/components/pages/rightBar";
import Reports from "@/components/pages/reports/index";
import Invoices from "@/components/pages/invoices/index";
import SingleInvoice from "@/components/pages/invoices/single";
import SUbsManger from "@/components/pages/subsmanager/index";
import Proforma from "@/components/pages/proforma/index";
import NewDashboard from "@/components/pages/dashboard/new";
import PieChart from "@/components/pages/dashboard/pie";
import DashboardSummary from "@/components/pages/dashboard/summary";
// /home/aio/Documents/_repos/Arnergy/arnergy-core-vue/src/components/pages/customerDashboard/index.vue
import CustomerDashboard from "@/components/pages/customerDashboard/index";
import Notifications from "@/components/pages/notifications/index";
import DashboardAnimatedIcons from "@/components/pages/dashboard/animated-icons";
import Warnings from "@/components/pages/warnings/index";
import Index2 from "@/components/pages/warnings/Index2";
import CustomerWarnings from "@/components/pages/customerWarning/index";
import Onboarding from "@/components/pages/onboarding";

// SubModules
import Payments from "@/components/pages/submodules/payments";
import Performance from "@/components/pages/submodules/performance";
import DeviceMgmt from "@/components/pages/submodules/devices";
import Support from "@/components/pages/submodules/support";
import Report from "@/components/pages/submodules/reports";
import Feedback from "@/components/pages/submodules/feedback";
import InventoryMgmt from "@/components/pages/submodules/inventory";
import UserMgmt from "@/components/pages/submodules/users";
import Customers from "@/components/pages/submodules/customers";
import AuditTrail from "@/components/pages/submodules/auditTrail";
import UserMgt from "@/components/pages/submodules/user_mgt.vue";
import CustomerAdmin from "@/components/pages/submodules/customer-admin.vue";
import CustomerPayment from "@/components/pages/submodules/payment.vue";
import ProcessPayment from "@/components/pages/payment/paymentProcess";
import ProcessPaymentFeedback from "@/components/pages/payment/Feedback";

// test build

// Onboarding
import OutrightSale from "@/components/pages/onboarding/outrightSale";
import OSAgreement from "@/components/pages/onboarding/outrightSale/OSAgreement.vue";
import OSSummary from "@/components/pages/onboarding/outrightSale/OSSummary.vue";
import OSFinish from "@/components/pages/onboarding/outrightSale/OSFinish.vue";

import LeaseToOwn from "@/components/pages/onboarding/leaseToOwn";
import LOSummary from "@/components/pages/onboarding/leaseToOwn/LOSummary.vue";
import JobInformation from "@/components/pages/onboarding/leaseToOwn/JobInformation.vue";
import LOAgreement from "@/components/pages/onboarding/leaseToOwn/LOAgreement.vue";
import BankStatement from "@/components/pages/onboarding/leaseToOwn/BankStatement.vue";
import CreditCheck from "@/components/pages/onboarding/leaseToOwn/CreditCheck.vue";
import KYC from "@/components/pages/onboarding/leaseToOwn/KYC.vue";
import PayDeposit from "@/components/pages/onboarding/leaseToOwn/PayDeposit.vue";
import LOFinish from "@/components/pages/onboarding/leaseToOwn/LOFinish.vue";
// import OnboardingLO from "@/components/pages/onboarding/LO";
// import OnboardingOS from "@/components/pages/onboarding/OS";

// import VueGoodTablePlugin from 'vue-good-table';

// // import the styles
// import 'vue-good-table/dist/vue-good-table.css'

// Vue.use(VueGoodTablePlugin);
import EmailVerified from "@/components/pages/EmailVerified.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    else return { x: 0, y: 500 };
  },
  routes: [
    {
      path: "/auth/register",
      name: "Register",
      component: Register,
      meta: {
        bodyClass: "p-front p-signup-helper",
        permission: "anon"
      }
    },
    {
      path: "/auth/email-verification",
      name: "EmailVerified",
      component: EmailVerified,
      meta: {
        permission: "anon"
      }
    },
    {
      path: "/onboarding/finish-tab",
      name: "FinishTab",
      component: FinishTab,
      meta: {
        permission: "anon"
      }
    },
    {
      path: "/customer_payment/:activetab",
      name: "customer_payment",
      component: CustomerPayment,
      meta: {
        permission: "anon"
      }
    },
    {
      path: "/onboarding",
      name: "Onboarding",
      component: Onboarding,
      meta: {
        permission: "anon"
      }
    },
    {
      path: "/auth/processPayment",
      name: "Register",
      component: ProcessPayment,
      meta: {
        permission: "anon"
      },
      alias: "/processPayment"
    },

    {
      path: "/auth/paymentFeedback",
      name: "Register",
      component: ProcessPaymentFeedback,
      meta: {
        permission: "anon"
      }
    },
    {
      path: "/customer_payment/:activetab",
      name: "customer_payment",
      component: CustomerPayment,
      meta: {
        permission: "anon"
      }
    },
    {
      path: "/customer_admin/:activetab",
      name: "customer_admin",
      component: CustomerAdmin,
      meta: {
        permission: "anon"
      }
    },
    {
      path: "/user_management/:activetab",
      name: "user_management",
      component: UserMgt,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/auth/login",
      name: "Login",
      component: Login,
      meta: {
        permission: "anon",
        bodyClass: "p-front"
      },
      alias: "/login"
    },
    {
      path: "/auth/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
      meta: {
        permission: "anon",
        bodyClass: "p-front"
      }
    },
    {
      path: "/auth/new-password/:uid/:token",
      name: "Password",
      component: Password,
      meta: {
        permission: "anon",
        bodyClass: "p-front"
      }
    },
    {
      path: "/auth/email-confirm/:uid/:token",
      name: "EmailConfirmed",
      component: EmailConfirmed,
      meta: {
        permission: "anon",
        bodyClass: "p-front"
      }
    },
    {
      path: "/onboarding/os",
      name: "OutrightSale",
      component: OutrightSale,
      children: [
        {
          path: "agreement",
          name: "OSAgreement",
          component: OSAgreement
        },
        {
          path: "summary",
          name: "OSSummary",
          component: OSSummary
        },
        {
          path: "finish",
          name: "OSFinish",
          component: OSFinish
        }
      ]
    },
    {
      path: "/onboarding/lo",
      name: "LeaseToOwn",
      component: LeaseToOwn,
      children: [
        {
          path: "summary",
          name: "LOSummary",
          component: LOSummary
        },
        // {
        //   path: "job-info",
        //   name: "JobInformation",
        //   component: JobInformation
        // },
        {
          path: "agreement",
          name: "LOAgreement",
          component: LOAgreement
        },
        // {
        //   path: "bank-statement",
        //   name: "BankStatement",
        //   component: BankStatement
        // },
        {
          path: "credit-check",
          name: "CreditCheck",
          component: CreditCheck
        },
        {
          path: "kyc",
          name: "KYC",
          component: KYC
        },
        {
          path: "deposit",
          name: "PayDeposit",
          component: PayDeposit
        },
        {
          path: "finish",
          name: "LOFinish",
          component: LOFinish
        }
      ]
    },
    {
      path: "/",
      name: "Home",
      component: PerformanceV2,
      meta: {
        permission: "CUSTOMER",
        fail: "/error"
      },
      alias: "/home"
    },
    {
      path: "/shs/generate-token",
      name: "GenerateToken",
      component: GenerateToken,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/shs/token-history",
      name: "TokenHistory",
      component: TokenHistory,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/wallet",
      name: "WalletMgmt",
      component: Wallet,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/transaction/response/*",
      name: "TransactionResponse",
      component: TransactionResponse,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/request",
      name: "deviceRequest",
      component: DeviceRequest,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/requests/manage",
      name: "manageRequests",
      component: ManageRequests,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/devices/new",
      name: "New",
      component: New,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/devices/list",
      name: "List",
      component: List,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/device/:deviceId/:activetab?",
      name: "viewDevices",
      component: View,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/device/performance/:deviceId/:version",
      name: "devicePerformance",
      component: devicePerformance,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/device/performance-v2/:deviceId/:version",
      name: "devicePerformanceV2",
      component: devicePerformanceV2,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/dashboard/performance/:deviceId",
      name: "newDashboard",
      component: NewDashboard,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/dashboard/performance/pie/:deviceId/:version",
      name: "pieChart",
      component: PieChart,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/dashboard/summary",
      name: "dashboardSummary",
      component: DashboardSummary,
      meta: {
        permission: "ADMIN"
      }
    },

    {
      path: "/dashboard/animated-icons",
      name: "DashboardAnimatedIcons",
      component: DashboardAnimatedIcons,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/customers",
      name: "customers",
      component: Customers,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/subsmanager",
      name: "subsmanager",
      component: SUbsManger,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/proforma",
      name: "proforma",
      component: Proforma,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/devices-status",
      name: "devices-status",
      component: Devices,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/onboarding-tracker",
      name: "onboarding-tracker",
      component: OnboardingTracker,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/admin-billing",
      name: "admin-billing",
      component: AdminBilling,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/lux-onboarding",
      name: "lux-onboarding",
      component: ListLuxUsers,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/lux-onboarding/create",
      name: "lux-onboarding-create",
      component: LuxOnboarding,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/lux-onboarding/update",
      name: "LuxDeviceUpdate",
      component: LuxDeviceUpdate,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/admin-transaction-history",
      name: "admin-transaction-history",
      component: AdminTransactionHistory,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/users/list",
      name: "Users",
      component: UsersIndex,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/billing",
      name: "billing",
      component: Billing,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/billing/transactionHistory",
      name: "transactionHistory",
      component: TransactionHistory,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/user/new",
      name: "UserCreate",
      component: UsersCreate
    },
    {
      path: "/user/billing",
      name: "BillingCreate",
      component: BillingCreate,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/user/billing-update",
      name: "BillingUpdate",
      component: BillingUpdate,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/customer/new",
      name: "CustomerCreate",
      component: CustomerCreate
    },
    {
      path: "/users/priviledges/:userId",
      name: "allowUser",
      component: UsersAllow,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/users/edit/:userId",
      name: "editUser",
      component: EditsAllow,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/profile/edit/:userId",
      name: "editUser",
      component: ProfileEdit,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/error",
      name: "Error",
      component: Error,
      meta: {
        permission: "anon|CUSTOMER",
        bodyClass: "p-front"
      }
    },
    {
      path: "/dashboard/CustomerDashboard",
      name: "customerDashboard",
      component: CustomerDashboard,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/dashboard/notifications",
      name: "notifications",
      component: Notifications,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/users/:userId",
      name: "UserDetails",
      component: UserDetails,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/kitchen",
      name: "uiKitchen",
      component: Kitchen,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/inventory/index",
      name: "inventoryIndex",
      component: Inventory,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/inventory/components",
      name: "inventoryComponents",
      component: Components,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/roles",
      name: "roles",
      component: Roles,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/report",
      name: "report",
      component: ReportConfig,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/alarm/config",
      name: "alarmConfig",
      component: Alarm,
      meta: {
        permission: "CUSTOMER"
      }
    },

    {
      path: "/enquiries",
      name: "enquiries",
      component: Enquiries,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/enquiries/:enqId",
      name: "viewEnquiry",
      component: viewEnquiries,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/device-request/:id",
      name: "deviceRequestStatus",
      component: deviceRequestStatus,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/instalations/approved",
      name: "instalationList",
      component: listInstallation,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/instalations/ongoing",
      name: "ongoingInstalation",
      component: ongoingInstallation,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/instalations/inventory-request/:Installation",
      name: "inventoryRequest",
      component: inventoryRequest,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/installation/commission/:Installation",
      name: "instalationCommission",
      component: installationCommission,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/instalation/schedule/:Installation",
      name: "instalationSchedule",
      component: instalationSchedule,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/shs/pay",
      name: "ravepay",
      component: ravePay,
      meta: {
        permission: "CUSTOMER"
      }
    },
    // SubModules
    {
      path: "/payments",
      name: "payments",
      component: Payments,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/performance/:live",
      name: "performance",
      component: PerformanceV2,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/performance-v2/:live",
      name: "performance",
      component: PerformanceV2,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/geo-distribution",
      name: "geoDistribution",
      component: geoDistribution,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/devices/:activetab",
      name: "devices",
      component: DeviceMgmt,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/support",
      name: "support",
      component: Support,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/report/config",
      name: "reportConfig",
      component: Report,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/feedback",
      name: "feedback",
      component: Feedback,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/packages",
      name: "packages",
      component: PackagesMgmt,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/inventory",
      name: "inventory",
      component: InventoryMgmt,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/usersmanage",
      name: "usersmanage",
      component: UserMgmt,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/audittrail",
      name: "audittrail",
      component: AuditTrail,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/rightbar",
      name: "rightBar",
      component: rightBar,
      meta: {
        permission: "CUSTOMER"
      }
    },
    {
      path: "/reports",
      name: "reports",
      component: Reports,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/invoices",
      name: "invoices",
      component: Invoices,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/invoices/:single",
      name: "singleinvoice",
      component: SingleInvoice,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/warnings",
      name: "warnings",
      component: Warnings,
      meta: {
        permission: "ADMIN"
      }
    },
    // Warning_Index2
    {
      path: "/warnings2",
      name: "Index2",
      component: Index2,
      meta: {
        permission: "ADMIN"
      }
    },
    {
      path: "/customerWarning",
      name: "customerWarnings",
      component: CustomerWarnings,
      meta: {
        permission: "CUSTOMER"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js